"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedMarkups = {
    "ascii": true,
    "unicode": true,
    "html": true
};
//# sourceMappingURL=options.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/options.js
// module id = 43
// module chunks = 0 1 2 3